import { render, staticRenderFns } from "./SMSMessage.vue?vue&type=template&id=00e28dec"
import script from "./SMSMessage.vue?vue&type=script&lang=js"
export * from "./SMSMessage.vue?vue&type=script&lang=js"
import style0 from "./SMSMessage.vue?vue&type=style&index=0&id=00e28dec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports